module.exports = __webpack_public_path__ + "img/fo.72c9a70e.svg";